import {
  cssVar
} from "../../../components/cssInJs";
import { mergeStyles } from "react-select";


/** cache the react select theme based on the theme store */

/**
 * result should be passed to styles prop for pretty much all uses of react-select in the application to maintain visual consistency
 * @param styles
 * @returns {*} - object to be passed to ReactSelect.styles prop. Named keys that accept the current style and add additional styles
 */
export default function reactSelectStyles(styles = {}) {
  return mergeStyles(
    {
      container: (s, state) => ({
        ...s
      }),
      option: (s, state) => ({
        ...s,
        ...(state.isSelected && { color: "var(--dropdown-link-hover-color)" })
      }),
      control: (s, state) => ({
        ...s,
        color: "var(--body-color)",
        backgroundColor: "var(--input-bg)",
        boxShadow: "none",
        cursor: "pointer",
        minHeight: "unset !important",
        borderRadius: "var(--border-radius)",
        border: "var(--input-border)",
        backgroundClip: "padding-box"
      }),
      singleValue: (s) => ({
        ...s,
        color: "var(--body-color)"
      }),
      multiValue: (s) => ({
        ...s,
        color: "var(--body-color)"
      }),
      menu: s => ({
        ...s,
        boxShadow: "none",
        border: "var(--card-border) !important",
        backgroundColor: "var(--elevated-component-bg)",
        backdropFilter: "var(--backdrop-blur-4)",
        borderRadius: "var(--card-border-radius)",
        marginTop: "0",
        boxShadow: "var(--drop-shadow-4)",
        zIndex: 100,
        overflowY: "hidden"
      }),
      menuPortal: (providedStyle, position) => {
        return { ...providedStyle, background: "none", border: "var(--card-border) !important", zIndex: 9999 };
      },
      placeholder: s => ({ ...s, color: "var(--input-color)" }),
      input: s => ({...s, color: "var(--body-color)", borderColor: "var(--input-border-color)", paddingTop: "var(--input-padding-y)", paddingBottom: "var(--input-padding-y)"})
    },
    styles
  );
}
